//* Local or Custom Libraries
import { convertDecimalToDollars } from "@lululemon/ecom-common/src/util/helpers";

const DEFAULT_PRICING = {
  listPrice: "$ -",
  salePrice: [],
  currencyCode: "USD",
  recommendation: false,
};

/**
 * Calculates and formats the pricing details for a product.
 * @param {Object} product - The product object containing pricing information.
 * @returns {Object} The formatted pricing details for the product.
 * @throws {Error} Throws an error if the product object is invalid.
 */
export const getProductPricing = (product) => {
  const pricing = { ...DEFAULT_PRICING };

  if (!product || typeof product !== "object") {
    console.error("Invalid product data. Returning default pricing object.");
    return pricing;
  }

  const {
    "product-on-sale": productOnSale,
    "product-sale-price": productSalePriceRaw,
    "sale-price": salePriceRaw,
    "list-price": listPriceRaw,
    "currency-code": currencyCode,
  } = product;

  const productIsOnSale = productOnSale === "1";
  const listPrice = listPriceRaw
    ? convertDecimalToDollars(listPriceRaw)
    : DEFAULT_PRICING.listPrice;
  const productSalePrice = productSalePriceRaw ?? salePriceRaw;

  pricing.listPrice = listPrice;
  pricing.currencyCode = currencyCode;

  if (productIsOnSale) {
    pricing.recommendation = true;

    if (Array.isArray(productSalePrice) && productSalePrice.length > 0) {
      //* Products with Single and Multiple sale prices
      pricing.salePrice = productSalePrice.map(convertDecimalToDollars);
    } else if (typeof productSalePrice === "string") {
      //* Handle products with Fallback price
      pricing.salePrice = [convertDecimalToDollars(productSalePrice)];
    }
  }

  return pricing;
};
